import React from 'react';
import { Link } from 'react-router-dom';
// Import translation
import i18n from 'i18next';

export const createColumns = (handleSelectItem, isReadOnly) => [
	{
		Header: i18n.t('menu:table_columns.name'),
		accessor: 'name',
		Cell: ({
			row: {
				_original: { id, name, parent_id }
			}
		}) => (
			<Link to={`/panel/menus/${parent_id}/edit/${id}/metadata`}>{name}</Link>
		)
	},
	{
		Header: i18n.t('menu:table_columns.order'),
		accessor: 'order'
	},
	{
		Header: i18n.t('menu:table_columns.created_at'),
		accessor: 'created_at',
		sortable: false
	},
	{
		Header: i18n.t('menu:table_columns.updated_at'),
		accessor: 'updated_at',
		sortable: false
	},
	{
		Header: i18n.t('common:table_columns.delete'),
		accessor: 'delete',
		width: 60,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { id }
			}
		}) =>
			!isReadOnly && (
				<button
					onClick={() => handleSelectItem(id)}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-trash" />
				</button>
			)
	}
];
